import React from 'react';
import styled from 'styled-components';
import Section from '~/App/shared/components/Layout/Section';
import StructuredText from '~/App/components/DatoCMS/StructuredText';
import { StructuredTextData } from '~/App/shared/interfaces/datoCMS';
import { Nullable } from '~/App/shared/types/Nullable';

const StructuredTextWrapper = styled.div`
  p {
    margin-bottom: 1.5rem;
  }
`;

interface Props {
  text?: Nullable<StructuredTextData>;
  seoInfo?: Nullable<StructuredTextData>;
}

const CarInformationSection = ({ text, seoInfo }: Props) => {
  return (
    <>
      {(text || seoInfo) && (
        <Section
          maxWidth={64}
          spacingTop={3.5}
          spacingBottom={0.5}
          backgroundColor="light"
        >
          {text && (
            <StructuredText data={text} wrapper={StructuredTextWrapper} />
          )}
          {seoInfo && (
            <StructuredText data={seoInfo} wrapper={StructuredTextWrapper} />
          )}
        </Section>
      )}
    </>
  );
};

export default CarInformationSection;
